export var ModelColor;
(function (ModelColor) {
    ModelColor["black"] = "black";
    ModelColor["red"] = "red";
    ModelColor["yellow"] = "yellow";
    ModelColor["infected"] = "infected";
})(ModelColor || (ModelColor = {}));
export var ModelType;
(function (ModelType) {
    ModelType["dry"] = "dry";
    ModelType["damp"] = "damp";
    ModelType["wet"] = "wet";
})(ModelType || (ModelType = {}));
